/** Appendix A `offline`: a persistent, non-modal banner; nothing entered is lost. */
import { useIntl } from '@windrop/ui';
import { OFFLINE_KEY, useOnlineStatus } from '../lib/offline';

export function OfflineBanner() {
  const online = useOnlineStatus();
  const { t } = useIntl();
  if (online) return null;
  return (
    <div className="offline-banner" role="status" data-testid="offline-banner">
      {t(OFFLINE_KEY)}
    </div>
  );
}
